import CONFIG from '@config';

const makeIndexName = (name) => {
  return `${CONFIG.algolia.index_prefix}${name}`;
};

export default makeIndexName;
